// src/admin/utils/collections.ts
// Labels + tone maps for the collection_outcome / collection_channel enums
// and the synthetic bucket shown in the queue. Centralised here so the
// queue screen, case detail, and log-contact modal all speak the same
// language.

import type { Database } from '@/lib/database.types';
import type { Bucket } from '@admin/hooks/useCollectionsQueue';

type CollectionOutcome = Database['public']['Enums']['collection_outcome'];
type CollectionChannel = Database['public']['Enums']['collection_channel'];

export const OUTCOME_LABEL: Record<CollectionOutcome, string> = {
  no_answer: 'No answer',
  reached_promise: 'Promise to pay',
  reached_disputed: 'Disputed',
  reached_refused: 'Refused to pay',
  wrong_number: 'Wrong number',
  left_message: 'Left message',
};

export const OUTCOME_TONE: Record<CollectionOutcome, 'neutral' | 'positive' | 'warn' | 'danger' | 'info'> = {
  no_answer: 'neutral',
  reached_promise: 'positive',
  reached_disputed: 'warn',
  reached_refused: 'danger',
  wrong_number: 'warn',
  left_message: 'info',
};

export const CHANNEL_LABEL: Record<CollectionChannel, string> = {
  call: 'Call',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
  visit: 'Visit',
  email: 'Email',
};

export const BUCKET_LABEL: Record<Bucket, string> = {
  '0_14d': '0–14 days',
  '14_30d': '14–30 days',
  '30_60d': '30–60 days',
  '60_90d': '60–90 days',
  default: '90+ days',
};

// Short form for the days-overdue chip in the queue table.
export function daysChipClass(days: number): 'days-red' | 'days-amber' | 'days-grey' {
  if (days >= 30) return 'days-red';
  if (days >= 14) return 'days-amber';
  return 'days-grey';
}
